const WarningFill: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g id="Action/warning-Fill">
      <path
        id="Icon"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8259 21H4.12431C3.35503 21 2.66771 20.5986 2.2848 19.9257C1.90188 19.2528 1.90532 18.4515 2.29375 17.7821L10.2723 4.02843C10.6456 3.38401 11.3102 3 12.0499 3H12.0533C12.7943 3.00139 13.4596 3.38818 13.8315 4.03468L21.7033 17.7126C22.098 18.398 22.0987 19.2167 21.7068 19.9035C21.3149 20.5903 20.6118 21 19.8259 21ZM11.9958 15.1636C11.5261 15.1636 11.1453 14.7796 11.1453 14.306V8.85761C11.1453 8.38401 11.5261 8 11.9958 8C12.4655 8 12.8463 8.38401 12.8463 8.85761V14.306C12.8463 14.7796 12.4655 15.1636 11.9958 15.1636ZM11 16.7524C11 17.3357 11.4704 17.81 12.0489 17.81C12.6274 17.81 13.0985 17.3357 13.0978 16.7524C13.0978 16.1691 12.6274 15.6948 12.0489 15.6948C11.4704 15.6948 11 16.1691 11 16.7524Z"
        fill="#E78A08"
      />
    </g>
  </svg>
);

export default WarningFill;
